(ns dashboard.entity.analysis.modals
  (:require [dashboard.entity.analysis.applied-analysis :as applied.analysis]
            [dashboard.entity.analysis.applied-db :as applied.db]
            [dashboard.entity.question.analysis-search :as question.analysis.search]
            [dashboard.services.document-list :as document-list]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

;; ----------------------------------------------------------------------------
;;  Modal for viewing and editing analysis
;; ----------------------------------------------------------------------------

(rf/reg-event-fx
 ::show-editor-modal
  ;; Note that applied-structured-analysis can be nil, when the latest applied
  ;; analysis at that moment is wanted
 (fn [{:keys [db]} [_ analysis-id mode applied-structured-analysis]]
   {:fx (cond-> []
          (= :edit mode) (conj [:dispatch [::document-list/get]])
          :else
          (into
           [[:dispatch
             [::applied.db/get-linked-answers
              (if applied-structured-analysis
                (:construct-id applied-structured-analysis)
                ;; Use latest version if specific version not requested
                (get-in db [:applied-analyses
                            :data
                            analysis-id
                            0
                            :construct-id]))]]
            [:dispatch
             [::applied.db/get-linked-evidence
              (if applied-structured-analysis
                (:applied-structured-analysis-id applied-structured-analysis)
                         ;; Use latest version if specific version not requested
                (get-in db [:applied-analyses
                            :data
                            analysis-id
                            0
                            :applied-structured-analysis-id]))]]
            [:dispatch
             [::applied.db/get-last-references-by-date false]]
            [:dispatch
             [::ui/push-modal
              {:component #'applied.analysis/editor-modal
               :ctx {:edit-state (when (= :edit mode)
                                   (or applied-structured-analysis
                                       (applied.db/make-empty-editor-state
                                        (get-in db [:structured-analyses
                                                    :data
                                                    analysis-id
                                                    0]))))
                     :analysis-id analysis-id
                     :mode mode
                     :applied-structured-analysis applied-structured-analysis}
               :content-props {:style {:width "80vw"
                                       :max-height "100vh"
                                       :padding 0}}}]]]))}))

(defn show-editor-modal
  [mode analysis-id applied-structured-analysis]
  (rf/dispatch [::show-editor-modal analysis-id mode applied-structured-analysis]))

;; ----------------------------------------------------------------------------
;;  Modal for linking a question to analysis
;; ----------------------------------------------------------------------------

(rf/reg-event-fx
 ::show-browse-applied-analyses-modal
 (fn [_ [_ applied-analysis-version-ids on-submit question]]
   {:fx [[:dispatch
          [::ui/push-modal
           {:component question.analysis.search/search-analysis-by-category-modal
            :ctx {:applied-analysis-version-ids applied-analysis-version-ids
                  :category nil
                  :on-click-construct (partial show-editor-modal :view)
                  :on-click-state (fn [cid asa]
                                    (show-editor-modal
                                     (if (:next-version-id asa) :view :edit)
                                     cid
                                     asa))
                  :on-submit (fn [& args]
                               (apply on-submit args)
                               (rf/dispatch [::ui/pop-modal]))
                  :question question}
            :content-props {:style {:min-width "75vw" :max-height "90vh" :padding 0}}}]]]}))

(defn select-analyses-for-question
  [applied-analysis-version-ids on-submit question]
  (rf/dispatch [::show-browse-applied-analyses-modal applied-analysis-version-ids on-submit question]))